import { createGlobalStyle } from 'styled-components';
import defaultStyles from '@alweb-merkator/shared/styles/defaultStyles';

const GlobalStyles = createGlobalStyle`
  ${defaultStyles};
`;

export default GlobalStyles;
